import React from "react";
import { useUscSelector } from "../../../../../redux/store";
import { showUscPriceSelector } from "../../../../../utils/priceUtils";
import UscFinanceToggle from "./UscFinanceToggle";
import UscVehicleDisclaimers from "./UscVehicleDisclaimers";
import type { UscTrackingLocation } from "../../../../../utils/tracking";
import UscVehicleStatus from "./UscVehicleStatus";
import UscVehicleDealerAndSaleType from "./UscVehicleDealerAndSaleType";
import * as Styles from "./UscVehicleInformation.styles";

type UscVehicleInformationPropsType = {
    trackingLocation: UscTrackingLocation;
};

const UscVehicleInformation = ({ trackingLocation }: UscVehicleInformationPropsType): JSX.Element | null => {
    const showPrice = useUscSelector(showUscPriceSelector);
    const result = useUscSelector((state) => state.vehicle.result);

    if (!result) return null;

    return (
        <Styles.Wrapper>
            <UscVehicleStatus />
            <UscVehicleDealerAndSaleType />
            {showPrice && <UscFinanceToggle trackingLocation={trackingLocation} inBasket inModal={false} />}
            <UscVehicleDisclaimers />
        </Styles.Wrapper>
    );
};

export default UscVehicleInformation;
